import classNames from 'classnames';
import { observer } from 'mobx-react-lite';
import { FC } from 'react';

import { DotsIcon } from '@gem/icons';
import { IconButton, IconViewSizes, usePopover, PopoverMenu } from '@gem/ui-kit';

import { useChatSettingsPresenter } from './ChatSettings.presenter';
import styles from './ChatSettings.styles.m.css';

export const ChatSettings: FC = observer(() => {
  const presenter = useChatSettingsPresenter();
  const popover = usePopover<HTMLButtonElement>();

  const iconClass = classNames(styles.icon, {
    [styles.opened]: popover.isOpened,
  });

  return (
    <>
      <IconButton
        className={iconClass}
        setRef={popover.containerRef}
        Icon={DotsIcon}
        onClick={popover.toggle}
        size={IconViewSizes.Big}
        dataTest="chat-settings-button"
      />
      <PopoverMenu
        className={styles.popover}
        isOpened={popover.isOpened}
        placement="bottom-end"
        menuItems={presenter.menuItems}
        reference={popover.containerRef.current}
        onClose={popover.close}
      />
    </>
  );
});
